const EmployeePermission = {

    // FIELDS
    "employee": "Empleyado",
    "permission": "Pahintulot",

    // PAGE HEADER
    "employee_permission": "Pahintulot ng Empleyado",

    // ERROR
    "error_employee": "Piliin ang Empleyado",
    "error_permission": "Piliin ang Hindi Bababa sa Isang Pahintulot",

}

export default EmployeePermission;